// Plan order for display: Starter, Growth, Enterprise, Pro
export const SUBSCRIPTION_PLANS = {
  STARTER: {
    planName: "Starter",
    minPrepaidRecharge: 30000,
    pricePerReport: 5,
    validity: "1 year",
    integrationCharges: {
      modelA: 20000,
      modelB: 100000,
    },
    reportsLimit: 6000,
    features: {
      pdfSmartReports: {
        compact: true,
        advanced: true,
        dynamic: false,
        historical: false,
      },
      addOns: {
        consolidatedSummaryWithDiet: false,
        covepage: false,
        testRecommendation: false,
        riskScore: false,
      },
      personalisedServices: {
        vizapp: false,
        videoreport: false,
        languageSupport: false,
        whatsappChatbot: false,
        analyticsDashboard: false,
      },
      customisation: {
        contentCustomisation: false,
        designCustomisation: false,
      },
    },
  },
  GROWTH: {
    planName: "Growth",
    minPrepaidRecharge: 75000,
    pricePerReport: 7.5,
    validity: "1 year",
    integrationCharges: {
      modelA: 20000,
      modelB: 100000,
    },
    reportsLimit: 10000,
    features: {
      pdfSmartReports: {
        compact: true,
        advanced: true,
        dynamic: true,
        historical: true,
      },
      addOns: {
        consolidatedSummaryWithDiet: true,
        covepage: true,
        testRecommendation: true,
        riskScore: true,
      },
      personalisedServices: {
        vizapp: false,
        videoreport: false,
        languageSupport: false,
        whatsappChatbot: false,
        analyticsDashboard: false,
      },
      customisation: {
        contentCustomisation: false,
        designCustomisation: false,
      },
    },
  },
  ENTERPRISE: {
    planName: "Enterprise",
    minPrepaidRecharge: 100000,
    pricePerReport: 8,
    validity: "1 year",
    integrationCharges: {
      modelA: 20000,
      modelB: 100000,
    },
    reportsLimit: 12500,
    features: {
      pdfSmartReports: {
        compact: true,
        advanced: true,
        dynamic: true,
        historical: true,
      },
      addOns: {
        consolidatedSummaryWithDiet: true,
        covepage: true,
        testRecommendation: true,
        riskScore: true,
      },
      personalisedServices: {
        vizapp: true,
        videoreport: false,
        languageSupport: true,
        whatsappChatbot: false,
        analyticsDashboard: false,
      },
      customisation: {
        contentCustomisation: true,
        designCustomisation: false,
      },
    },
  },
  PRO: {
    planName: "Pro",
    minPrepaidRecharge: 150000,
    pricePerReport: 10,
    validity: "1 year",
    integrationCharges: {
      modelA: 20000,
      modelB: 100000,
    },
    reportsLimit: 15000,
    features: {
      pdfSmartReports: {
        compact: true,
        advanced: true,
        dynamic: true,
        historical: true,
      },
      addOns: {
        consolidatedSummaryWithDiet: true,
        covepage: true,
        testRecommendation: true,
        riskScore: true,
      },
      personalisedServices: {
        vizapp: true,
        videoreport: true,
        languageSupport: true,
        whatsappChatbot: true,
        analyticsDashboard: true,
      },
      customisation: {
        contentCustomisation: true,
        designCustomisation: true,
      },
    },
  },
};

// Display order: Starter, Growth, Enterprise, Pro
export const PLAN_ORDER = ["STARTER", "GROWTH", "ENTERPRISE"];
